import React, { Fragment } from 'react'
import * as Logger from 'loglevel'
import {
  Row,
  Col,
  Table,
  Overlay,
  OverlayTrigger,
  Tooltip,
  Popover
} from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrash,
  faSortUp,
  faSortDown,
  faFileAudio,
  faEdit,
  faKey,
  faUserSlash,
  faUserCheck,
  faPlusCircle,
  faMinusCircle,
  faTasks,
  faRss,
  faArrowCircleRight,
  faSave
} from '@fortawesome/free-solid-svg-icons'
import CollapsibleRow from './CollapsibleRow'

// redux:

import {
  sort,
  SortOrder,
  filterSearch,
  updateDataPublishedTime
} from './util/DataHandler'

import TableToolbar from './tools/TableToolbar'
import { css } from '@emotion/core'
import BounceLoader from 'react-spinners/BounceLoader'
import BeatLoader from 'react-spinners/BeatLoader'
import ClipLoader from 'react-spinners/ClipLoader'
import { DataEditor } from '../../DataEditor/DataEditor'

import * as HubConstant from './util/HubConstant'
import * as _ from 'lodash'
import Utilities, { UtilConstant } from 'hub-utilities'

import { RotatingArrow } from '../../RotatingArrow/RotatingArrow'

import DateTimePicker from 'react-datetime-picker'

import EditableDiv from './tools/EditableDiv'

// import Authorize from 'components/api-authorization/AuthorizeService';

import '../styles/DataTable.scss'
import '../styles/Calendar.scss'
import { PopupContent } from '../../PopupContent/PopupContent'
import UnsavedChangesPopup from './UnsavedChangesPopup'

import NavigationPrompt from 'react-router-navigation-prompt'
import { withRouter, Router } from 'react-router-dom'
import {TableRowAction} from './DataTable'

export default class TableHeader extends React.Component {
    constructor(props) {
        super(props)
    }
    areAllValsSelected = () => {
        var dataToSelect =
          this.props.filteredData.length > 0
            ? this.props.filteredData
            : this.props.data
    
        // determine row nums involved:
        var topRowIndex =
          (this.props.currentPageNum - 1) * this.props.numOfRowsPerPage
        var bottomRowIndex =
          dataToSelect.length >
          this.props.currentPageNum * this.props.numOfRowsPerPage
            ? this.props.currentPageNum * this.props.numOfRowsPerPage - 1
            : dataToSelect.length - 1
    
        if (dataToSelect.length === 0) return false
    
        var valCount = 0
        for (var i = 0; i < dataToSelect.length; i++) {
          if (i >= topRowIndex && i <= bottomRowIndex) {
            var attr = dataToSelect[i]
            var foundAttr =
              attr[
                this.props.dataKeys.find((keyObj) => {
                  return !!keyObj.shouldShowCheckbox
                }).key
              ]
            // to prevent crashing due to formVal not found
            if (foundAttr && foundAttr.formVal) {
              var formVal = foundAttr.formVal
              for (var j = 0; j < formVal.length; j++) {
                var actualVal = formVal[j]
                if (!actualVal.isChecked) return false
    
                valCount++
              }
            } else return false
          }
        }
        if (valCount === 0) return false // if there's no checkbox in that page, false
        return true
      }

      
  selectAllValues = () => {
    var dataToSelect =
      this.props.filteredData.length > 0
        ? this.props.filteredData
        : this.props.data
    Logger.debug((this.props.currentPageNum - 1) * this.props.numOfRowsPerPage)
    Logger.debug(this.props.currentPageNum * this.props.numOfRowsPerPage)
    Logger.debug(dataToSelect)

    var shouldSelectAllVals = !this.areAllValsSelected()

    dataToSelect.forEach((attr, index) => {
      var bottomRowVal =
        dataToSelect.length >
        this.props.currentPageNum * this.props.numOfRowsPerPage
          ? this.props.currentPageNum * this.props.numOfRowsPerPage
          : dataToSelect.length

      if (
        index >=
          (this.props.currentPageNum - 1) * this.props.numOfRowsPerPage &&
        index < bottomRowVal
      ) {
        /// \Logger.debug(attr[this.props.dataKeys.find(keyObj => { return !!keyObj.shouldShowCheckbox; }).key]);
        // below prevents crashing
        var selectedVal =
          attr[
            this.props.dataKeys.find((keyObj) => {
              return !!keyObj.shouldShowCheckbox
            }).key
          ]
        if (selectedVal && selectedVal.formVal) {
          selectedVal.formVal.forEach((actualVal) => {
            this.props.onSelectValue(
              attr.id,
              actualVal.index,
              shouldSelectAllVals
            )
          })
        }
      }
    })
  }
  
    generateTableHeaderSortArrows(i) {
        return (
          <Fragment>
            <FontAwesomeIcon
              id={i}
              className={
                this.props.sortConfig.order === SortOrder.ASCENDING &&
                this.props.dataKeys[i].key === this.props.sortConfig.key
                  ? 'sortUpActive'
                  : this.props.dataKeys[i].key !== this.props.sortConfig.key
                  ? 'sortUpInactiveBoth'
                  : 'sortUpInactive'
              }
              icon={faSortUp}
            />
            <FontAwesomeIcon
              id={i}
              className={
                this.props.sortConfig.order === SortOrder.DESCENDING &&
                this.props.dataKeys[i].key === this.props.sortConfig.key
                  ? 'sortDownActive'
                  : this.props.dataKeys[i].key !== this.props.sortConfig.key
                  ? 'sortDownInactiveBoth'
                  : 'sortDownInactive'
              }
              icon={faSortDown}
            />
          </Fragment>
        )
      }

    generateTableHeaderMainPart(i) {
        return (
          <Fragment key={`TableHeaderMainPart${i}`}>
            {this.props.dataKeys[i].shouldShowCheckbox ? (
              <OverlayTrigger
                key='checkbox_allRow'
                placement='bottom'
                overlay={
                  <Tooltip className='rowActionTooltip'>
                    {this.areAllValsSelected() ? 'Deselect All' : `Select All`}
                  </Tooltip>
                }
              >
                <div style={{ display: 'inline-block' }}>
                  <label className='checkboxContainer tableHeaderCheckAll'>
                    <input
                      id={`checkbox_all_${this.props.dataKeys[i].key}`}
                      name={`checkbox_all_${this.props.dataKeys[i].key}`}
                      className='filterGroupChild'
                      type='checkbox'
                      onChange={this.selectAllValues}
                      // onChange={(e) => this.handleCheckboxChange(e, availableFilterObjs, objsToFilter, null)}
                      checked={this.areAllValsSelected()}
                    />
                    <span className='checkmark' />
                  </label>
                </div>
              </OverlayTrigger>
            ) : (
              <Fragment />
            )}
            {this.props.dataKeys[i].headerIcon ? (
              <FontAwesomeIcon icon={this.props.dataKeys[i].headerIcon} />
            ) : (
              this.props.dataKeys[i].key.replace(/([a-z])([A-Z])/g, '$1 $2')
            )}
          </Fragment>
        )
      }

    generateTableHeader(i) {
        return (
          <td
            key={`TableHeader${i}`}
            id={i}
            name={i}
            className={
              `${this.props.dataKeys[i].canSort ? 'canSort ' : ''}` +
              i +
              ` ${this.props.dataKeys[i].hasRowIcon ? 'beforeIcon' : ''}`
            }
            colSpan={
              // align sort arrows to the right corner if there's only 1 sortdiv
              !!this.props.dataKeys && this.props.dataKeys.length !== 1
                ? 1
                : 1 + this.props.headerConfig.rowActions.length
            }
            onClick={(e) => {
              if (this.props.dataKeys[i].canSort)
                this.props.resortTableThenFilterByKey(
                  e.target.id,
                  this.props.sortConfig.order === SortOrder.ASCENDING
                    ? SortOrder.DESCENDING
                    : this.props.sortConfig.order === SortOrder.DESCENDING
                    ? SortOrder.ASCENDING
                    : SortOrder.ASCENDING
                )
            }}
          >
            <Row id={i}>
              <Col id={i} xs='8' className='p-0'>
                {this.generateTableHeaderMainPart(i)}
              </Col>
              <Col
                id={i}
                xs='4'
                className={`p-0 ${this.props.dataKeys[i].canSort ? 'sortDiv' : ''}`}
              >
                {this.props.dataKeys[i].canSort ? (
                  this.generateTableHeaderSortArrows(i)
                ) : (
                  <Fragment />
                )}
              </Col>
            </Row>
          </td>
        )
      }

    generateTableHeaders() {
        var tableHeaders = []
        if (
          this.props.headerConfig.rowActions.some(
            (action) =>
              action.action === TableRowAction.CHECKBOX 
              // && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
          )
        )
          tableHeaders.push(
            <td className='canSort' key='Select'>
              <Row>
                <Col xs='12' />
              </Row>
            </td>
          ) // for checkbox
    
        if (this.props.hasCollapsibleRows)
          tableHeaders.push(
            <th
              key='headers'
              style={{ backgroundColor: 'rgba(52, 58, 64, 0.9)' }}
            />
          ) // for collapsibleRows:
    
        for (var i = 0; i < this.props.dataKeys.length; i++) {
          // only accepts upper case first letter
          // have to assign id to every child, since sometimes onClick detects clicks from the children
          if (
            this.props.dataKeys[i].key[0] ===
            this.props.dataKeys[i].key[0].toUpperCase()
          ) {
            tableHeaders.push(
              <Fragment key={`tableHeader_Fragment_${i}`}>
                {this.props.dataKeys[i].headerIcon ? (
                  <OverlayTrigger
                    key={`headerIcon${i}`}
                    placement='top-start'
                    overlay={
                      <Tooltip
                        className={`rowActionTooltip ${
                          this.props.dataKeys[i].hasRowIcon ? 'withRowIcon' : ''
                        }`}
                      >
                        {this.props.dataKeys[i].key
                          .replace(/([A-Z])/g, ' $1')
                          .trim()}
                      </Tooltip>
                    }
                  >
                    {this.generateTableHeader(i)}
                  </OverlayTrigger>
                ) : (
                  this.generateTableHeader(i)
                )}
              </Fragment>
            )
          }
        }
    
        var rowActions = this.props.headerConfig.rowActions
        for (let i = 0; i < rowActions.length; i++) {
          // align sort arrows to the right corner if there's only 1 sortdiv
          if (
            !!this.props.dataKeys &&
            this.props.dataKeys.length !== 1 &&
            // this.props.authorizeService.getUserType() <=
            //   rowActions[i].minAuthorityRequired &&
            rowActions[i].action !== TableRowAction.DELETE_ROW_VALUE
          ) {
            tableHeaders.push(
              <th
                style={{ backgroundColor: 'rgba(52, 58, 64, 0.9)' }}
                key={'rowAction' + i}
              />
            ) // for rowtools
          }
        }
        if (this.props.numOfCols !== tableHeaders.length) {
          this.props.setNumOfCols(tableHeaders.length)
        }
    
        return (
          <thead>
            <tr>{tableHeaders}</tr>
          </thead>
        )
    }

    render() {
        return this.generateTableHeaders()
    }
}